import Vue from 'vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
// 防xss注入
Vue.use(VueDOMPurifyHTML)
